import React, { useEffect } from 'react'
import { Dispatch } from 'redux'
import { IPublishedGraphic } from '../../types/publishedGraphic'
import { getPublishedGraphicById } from '../../actions/publishedGraphic'
import { initialState as initGroup } from '../../reducers/group'
import { calendar } from '../../services/date'
import { getPublishedGraphicTag } from '../../services/publishedGraphic'
import { Main, Space } from '../../layouts'
import { Button, H1, H2, P, Breadcrumbs } from '../../components'
import { PublishedGraphicPreview } from './PublishedGraphicPreview'
import { PublishedGraphicSidebar } from './PublishedGraphicSidebar'
import { PublishedGraphicWrapper, StyledGraphicHeader } from './styled'
import { StyledMediaTypeLabel } from '../../components/SearchPreviewItems/styled'

export interface IPublishedGraphicPage {
  match: { params: { graphicId: string } }
  publishedGraphic: IPublishedGraphic
  hasGroupAccess: boolean
  dispatch: Dispatch
}

export const PublishedGraphicPage = ({
  match: {
    params: { graphicId },
  },
  publishedGraphic,
  hasGroupAccess,
  dispatch,
}: IPublishedGraphicPage) => {
  useEffect(() => {
    dispatch(getPublishedGraphicById(graphicId))
  }, [dispatch, graphicId])

  const {
    byline,
    lastPublishedDate,
    groupTitle,
    group,
    internalPackId,
    slugline,
    title,
    description,
    graphicType,
    graphicSubType,
    mediaType,
  } = publishedGraphic

  const publishedNote =
    byline &&
    lastPublishedDate &&
    `Published by ${byline}, ${calendar(lastPublishedDate)} in ${
      groupTitle || 'the'
    } group`

  const graphicTag = getPublishedGraphicTag(
    graphicType,
    graphicSubType,
    mediaType
  )

  return (
    <Main
      header={
        group && (
          <Breadcrumbs
            group={{
              ...initGroup,
              name: group,
              shortTitle: groupTitle || '',
            }}
          />
        )
      }
      sidebarSecondary={
        <PublishedGraphicSidebar publishedGraphic={publishedGraphic} />
      }
      scrollContent
      helmet={`Reuters Graphics. Portal: ${title}`}
    >
      <>
        <StyledGraphicHeader>
          <PublishedGraphicWrapper>
            <Space mb={4}>
              <H1 id="graphic-slugline">{slugline}</H1>
            </Space>
            <Space mb={3}>
              <H2 id="graphic-title">{title}</H2>
              {graphicTag && (
                <StyledMediaTypeLabel
                  className="type-tag"
                  label={graphicTag}
                  color="primary"
                />
              )}
            </Space>
            <P id="graphic-description">{description}</P>
            <P id="graphic-note" mb={4}>
              {publishedNote}
            </P>
          </PublishedGraphicWrapper>
          {hasGroupAccess && (
            <Button
              id="edit-graphic-button"
              type="submit"
              variant="contained"
              color="primary"
              to={`/group/${group}/pack/${internalPackId}?edition=overall-pack&tab=details`}
            >
              Edit this graphic
            </Button>
          )}
        </StyledGraphicHeader>
        <PublishedGraphicPreview publishedGraphic={publishedGraphic} />
      </>
    </Main>
  )
}
